import React from 'react';
import { Redirect } from 'react-router';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import RoleService from '../../services/utility/role';
import Taxes from './taxes/tax.component';
import TaxDetails from './taxes/tax.details.component';

const roleService = new RoleService();

export default function TaxRoutersComponent(props) {
  const { path } = useRouteMatch();

  const hasAccess = roleService.checkRouteAccess(props, 'TAX');
  if (hasAccess) {
    return (
      <React.Fragment>
        <Switch>
          <Route exact path={path}>
            {' '}
            <Taxes />{' '}
          </Route>
          <Route exact path="/taxes" component={Taxes} />
          <Route exact path="/taxes/:id" component={TaxDetails} />
        </Switch>
      </React.Fragment>
    );
  }
  return (
    <Redirect
      to={{
        pathname: '/unauthorized',
        state: {
          from: props.location,
        },
      }}
    />
  );
}
